var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.89844 12.5732C1.89844 11.7662 2.21903 10.9922 2.7897 10.4215C3.36037 9.85087 4.13436 9.53027 4.94141 9.53027H11.0273C11.8344 9.53027 12.6084 9.85087 13.179 10.4215C13.7497 10.9922 14.0703 11.7662 14.0703 12.5732C14.0703 12.9768 13.91 13.3638 13.6247 13.6491C13.3393 13.9344 12.9524 14.0947 12.5488 14.0947H3.41992C3.0164 14.0947 2.6294 13.9344 2.34407 13.6491C2.05874 13.3638 1.89844 12.9768 1.89844 12.5732Z",
    stroke: "#737791",
    strokeWidth: 1.90186,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98535 6.4873C9.24579 6.4873 10.2676 5.46552 10.2676 4.20508C10.2676 2.94464 9.24579 1.92285 7.98535 1.92285C6.72491 1.92285 5.70312 2.94464 5.70312 4.20508C5.70312 5.46552 6.72491 6.4873 7.98535 6.4873Z",
    stroke: "#737791",
    strokeWidth: 1.90186
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d58a88fc67999d11f90568f5cd3058b5.svg";
export { ForwardRef as ReactComponent };